import React, { forwardRef } from 'react';

import type { PressableProps } from '@atlaskit/primitives/compiled';
import { Pressable } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		backgroundColor: 'transparent',
		padding: 0,
		textDecoration: 'underline',
		textDecorationColor: token('color.text.subtlest'),
		color: token('color.text.subtlest'),
		'&:hover': { color: token('color.text') },
		'&:active': { color: token('color.link.pressed') },
	},
});

export type PressableLinkProps = React.ComponentProps<typeof Pressable>;
/**
 * PressableLink is a button styled to look like a link.
 * Use for non-navigation interactions where link-like appearance is desired.
 */
export const PressableLink: React.ForwardRefExoticComponent<
	Omit<Omit<PressableProps, 'ref'> & React.RefAttributes<HTMLButtonElement>, 'ref'> &
		React.RefAttributes<HTMLButtonElement>
> = forwardRef<HTMLButtonElement, PressableLinkProps>(({ onClick, children, ...rest }, ref) => (
	<Pressable ref={ref} xcss={styles.root} onClick={onClick} {...rest}>
		{children}
	</Pressable>
));

PressableLink.displayName = 'PressableLink';
